import React from "preact/compat";
import {h, Component} from 'preact';
import {connect} from "react-redux";
import reduce from "../reducers";
import * as actions from "../actions";
import WordArtCurveControls from "./WordArtCurveControls";
import WordArtShadowControls from "./WordArtShadowControls";

export default @connect(reduce, actions)
class AsideWordArt extends Component {
    constructor() {
        super()
    }

    render(props, state) {
        return (<div id="app-aside-wordart">
            <div className="title" style="margin-bottom: 16px;">Text Effects</div>
            <WordArtCurveControls/>
            <WordArtShadowControls/>
        </div>)
    }
}
